module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = 77
// module chunks = 0